<template>
  <div class="flex-col">
    <header class="flex justify-center flex-col">
      <div class="flex justify-center bg-orange-400 w-full text-center overflow-hidden h-20">
        <img class="h-20" src="https://i.imgur.com/iwEBie0.png" alt="Chuckle Hut Logo">
        <h1 class="title text-2xl p-4">{{ data.title }}</h1>
      </div>
      <p class="subtitle text-center text-white">{{ data.subtitle }}</p>
    </header>
    <section class="flex-col">
      <p class="flex justify-center">{{ data.description }}</p>
      <ul class="flex-row">
        <li class="flex justify-center max-h-[500px]" v-for="feature in data.features" :key="feature.id">
          <div class="transition duration-700 ease-in-out hover:scale-110 flex rounded-lg justify-center bg-gray-800 m-4 p-4 w-1/3 h-1/6">
            <div class="w-[400px] h-[400px] rounded-l-lg overflow-hidden">
              <img class="scale-150 translate-y-20" :src="feature.imgUrl">
            </div>
            <div class="w-1/3 rounded-r-lg border-gray-500 bg-gray-700">
              <span>{{ feature.icon }}</span>
              <h2 class="p-8">{{ feature.title }}</h2>
              <p class="p-8 w-full">{{ feature.description }}</p>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <footer class="m-4 flex justify-center">
      <p class="footer-text">{{ data.footerText }}</p>
    </footer>
  </div>
</template>

<script setup>
import { reactive } from 'vue';

// Data
const data = reactive({
  title: 'Welcome to Chuckle Hut',
  subtitle: 'Home of the Chuckle Sandwich',
  description: 'M - F 6pm - 2am, Sat - Sun 12pm - 12am',
  features: [
    {
      id: 1,
      icon: '',
      title: 'Monday Open Mic',
      description: 'Monday nights at 6pm are exclusively for open mic, come try your best material!',
      imgUrl: 'https://i.imgur.com/JeJhZyP.jpg'
    },
    {
      id: 2,
      icon: '',
      title: 'Friday Improv',
      description: 'Group and solo improv performances for 4 hours every Friday!',
      imgUrl: 'https://i.imgur.com/NMM2Q1O.jpg'
    },
    {
      id: 3,
      icon: '',
      title: 'Sunday Morning Movie Brunch',
      description: 'Ever watched the Godfather while being served waffles? No? Well, now you can.',
      imgUrl: 'https://i.imgur.com/KGEAv4l.jpg'
    }
  ],
  footerText: '© 2023 Chuck Hut. All rights reserved.'
});

</script>

<style scoped>
h2 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  /* padding: 4px; */
  color: white;
}

p {
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
  /* padding: 4px; */
  color: white;
}
</style>